<template>
  <div @click="closeEditPageName" class="bigScreen-list">
    <div class="page-top verticallyCenter">
      <div class="page-top-l">
        <a @click="backHistory" class="colfff8 backpage"><span class="icon-portal-return mr8"></span>返回</a>
      </div>
      <div class="flex1 talign-center">页面管理</div>
      <div class="page-top-r"></div>
    </div>
    <div class="w900 middle-content">
      <div class="verticallyCenter page-sets mb16">
        <div>
          <el-button type="primary" @click="openTemplatePop"><span class="icon-portal-plus mr8"></span>添加页面</el-button>
        </div>
      </div>
      <ul class="pagelist">
        <li class="page-list verticallyCenter" v-if="pagelist.length > 0">
          <img class="page-cover" :src="pagelist[0].cover" alt="" />
          <div v-show="editIndex !== 0" class="page-name">
            <div class="verticallyCenter">
              <p class="overflowHid2 mr8 hover-theme-color" @click="toEdit(pagelist[0])">
                {{ pagelist[0].name }}
              </p>
              <span class="icon-portal-edit hover-show" @click.stop="editPageName(0, pagelist[0].name)"></span>
            </div>
            <p class="fs13 first-tip">首页不可删除或调整顺序</p>
          </div>
          <div v-show="editIndex === 0" class="verticallyCenter page-name">
            <input class="page-name-inp" type="text" v-model="pageName" />
            <span class="fs14 baseColor mr16 handle-btn" @click="cancleEditPageName">取消</span>
            <span class="fs14 baseColor handle-btn" @click="saveEditPageName(pagelist[0])">保存</span>
          </div>
        </li>
      </ul>
      <!--  @end="handleDragEnd" :move="handleDragMove"-->
      <draggable element="ul" v-model="pagelist" handle=".mover" class="pagelist" @end="handleDragEnd">
        <li class="page-list verticallyCenter" v-for="(page, index) in pagelist" :key="index" v-if="index > 0">
          <el-tooltip class="item" effect="dark" content="拖拽调整顺序" placement="top-end">
            <span class="mover icon icon-portal-drag hover-show"></span>
          </el-tooltip>

          <img class="page-cover" :src="page.cover" :key="index" alt="" />
          <div v-show="editIndex !== index" class="verticallyCenter page-name">
            <p class="overflowHid2 mr8 hover-theme-color" @click="toEdit(page)">
              {{ page.name }}
            </p>
            <span class="icon-portal-edit hover-show" @click.stop="editPageName(index, page.name)"></span>
          </div>
          <div v-show="editIndex === index" class="verticallyCenter page-name">
            <input class="page-name-inp" type="text" v-model="pageName" />
            <span class="fs14 baseColor mr16 handle-btn" @click="cancleEditPageName">取消</span>
            <span class="fs14 baseColor handle-btn" @click="saveEditPageName(page)">保存</span>
          </div>
          <div class="right-btns" v-if="index > 0">
            <span class="icon icon-portal-delete hover-show" @click="deletePage(page.publicId, index)"></span>
          </div>
        </li>
      </draggable>
    </div>
    <div></div>
    <div
      tabindex="-1"
      role="dialog"
      aria-modal="true"
      aria-label="提示"
      class="el-message-box__wrapper"
      style="z-index: 2024"
      v-show="showTemplates"
    >
      <div class="el-message-box">
        <div class="el-message-box__header">
          <div class="el-message-box__title" v-if="showSubPage">
            <div class="return-btn" @click="showSubPage = false"><i class="icon-portal-arrows-left"></i>{{ pageTitle }}</div>
          </div>
          <div class="el-message-box__title" v-else><span>添加页面</span></div>
          <button type="button" aria-label="Close" class="el-message-box__headerbtn" @click="closeTemplate">
            <i class="el-message-box__close el-icon-close"></i>
          </button>
        </div>
        <div class="el-message-box__content">
          <div class="pop-content" v-if="!showSubPage">
            <div class="middle">
              <div class="page-name-wrap fs14 col333 mb16">
                <label>页面名称:</label>
                <input
                  type="text"
                  class="inp-name"
                  id="pageSearchKey"
                  placeholder="输入页面名称"
                  v-model="templatePageName"
                />
              </div>
              <div id="pageContainer">
                <p class="fs14 col333">选择模板:</p>
                <ul class="templates-types">
                  <li
                    :class="type.typeId == activeTemplateId ? 'active' : ''"
                    v-for="(type, index) in pageTemplateType"
                    :key="'type_' + index"
                    @click="changeTemplateType(type)"
                  >
                    {{ type.name }}
                  </li>
                </ul>
                <div v-show="pageTemplates.length == 0" class="empty">
                  <p class="fs14 col333">暂无内容~</p>
                </div>
                <ul class="pages-styles">
                  <li
                    class="fs12 col333"
                    v-for="(item, index) in pageTemplates"
                    :key="index"
                    :class="templatePageId === item.encId ? 'active' : ''"
                    @click="selectSubPage(item, index)"
                  >
                    <div class="cover-box">
                      <img
                        v-if="templatePageId === item.encId"
                        class="checked"
                        src="../assets/images/icon-checked.png"
                        alt=""
                      />
                      <img class="page-img" :src="item.cover" />
                    </div>
                    <p v-if="activeTemplateId !== '78A9CCC5337333FC'">{{ item.name }}</p>
                  </li>
                </ul>
              </div>
            </div>
          </div>
          <ul class="pages-styles marginTop0 maxHeight500" v-if="showSubPage">
            <li
              v-for="(item, index) in subPageTemplate"
              :class="subTemplatePageId === item.encId ? 'active' : ''"
              :key="index"
              @click="selectTemplatePage(item, index)"
            >
              <div class="cover-box">
                <img
                  v-if="subTemplatePageId === item.encId"
                  class="checked"
                  src="../assets/images/icon-checked.png"
                  alt=""
                />
                <img class="page-img" :src="item.cover || defaultImgSrc" />
              </div>
              <p class="textColor">{{ item.name }}</p>
            </li>
          </ul>
        </div>
        <div class="el-message-box__btns">
          <button type="button" class="el-button el-button--default el-button--small" @click="closeTemplate">
            <span> 取消 </span>
          </button>
          <el-button
            type="button"
            :loading="loading"
            class="el-button el-button--default el-button--small el-button--primary"
            @click="nextClick"
            v-if="!showSubPage"
          >
            <span> 确定 </span>
          </el-button>
          <el-button
            type="button"
            :loading="loading"
            class="el-button el-button--default el-button--small el-button--primary"
            @click="addSubPage"
            v-else
          >
            <span> 确定 </span>
          </el-button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import qs from "qs"
import "../assets/css/common.css"
import "../assets/icomoon/style.css"
import instance from "../interceptor"
import { getCookie, _debounce, replaceUrlParam } from "../utils/index"
import draggable from "vuedraggable"
import { getErrorMessage } from "utils/errorMessageMap.js"
export default {
  name: "bigScreenList",
  components: {
    draggable
  },
  data() {
    return {
      websiteId: undefined,
      wfwfid: undefined,
      pageId: undefined,
      pagelist: [],
      pageOrder: [],
      originalList: [],
      autoPlaySpeed: 20,
      autoplay: true,
      editIndex: undefined,
      pageName: "",
      pageTemplates: [],
      pageTemplateType: [
        {
          name: "系统模板",
          typeId: 21,
          systemType: 1
        },
        {
          name: "我的模板",
          typeId: 299,
          systemType: 3
        }
      ],
      activeTemplateId: 25,
      systemType: 1,
      contextPath: "",
      showTemplates: false,
      templatePageId: "",
      templatePageName: "",
      selectOption: [
        {
          label: "自动切换",
          value: true
        },
        {
          label: "手动切换",
          value: false
        }
      ],
      isPhoneFullScreenFlag: "",
      loading: false,
      showSubPage: false,
      pageTitle: "",
      subTemplatePageId: "",
      subPageTemplate: [],
      defaultImgSrc: require("../assets/images/default_image_home.png"),
      newRouterGo:""
    }
  },
  created() {
    const urlQuery = this.GetRequest()
    this.websiteId = urlQuery.w
    this.pageId = urlQuery.p
    this.getFid()
    this.isPhoneFullScreenFlag = urlQuery.t
    if (this.isPhoneFullScreenFlag == "true") {
      this.activeTemplateId = 25 //h5
    } else {
      this.activeTemplateId = 26 //pc
    }
    this.pageTemplateType = [
      {
        name: "系统模板",
        typeId: this.activeTemplateId,
        systemType: 1
      },
      {
        name: "我的模板",
        typeId: 299,
        systemType: 3
      }
    ]
  },
  mounted() {
    this.contextPath = window.hasOwnProperty("p_contextpath") ? window["p_contextpath"] : ""
    this.showPageList()
    // this.getListData()
  },
  methods: {
    handleDragMove(e) {
      if (e.relatedContext?.element?.publicId == this.originalList[0].publicId) return false
      //不允许拖拽
      if (e.draggedContext?.element?.publicId == this.originalList[0].publicId) return false
      return true
    },
    // 处理拖拽结束
    handleDragEnd(event) {
      // 没有发生数据交换则不发请求
      if (event.oldIndex === event.newIndex) return
      if (this.pagelist[0].publicId !== this.originalList[0].publicId) return
      this.savePageSet()
    },
    async getFid() {
      let myCookie = this.$store.state.states.myCookie
      if (!myCookie) myCookie = await getCookie("wfwfid")
      this.wfwfid = myCookie.wfwfid
    },
    toEdit(page) {
      if(!page.isHomePage && !page.template.includes("_sub") && !page.template.includes("_header") && !page.template.includes("_login")){
        sessionStorage.setItem("isEqualPage", true) // 标记当前跳转的页面是平级页面
      }
      let publicId = page.publicId
      window.location.href = `/v2/p/${publicId}/edit`
    },
    GetRequest() {
      let url = window.previewUrl || location.href //获取url中"?"符后的字串
      let theRequest = new Object()
      if (url.indexOf("?") != -1) {
        let str = url.split("?")[1]
        let strs = str.split("&")
        for (let i = 0; i < strs.length; i++) {
          theRequest[strs[i].split("=")[0]] = decodeURI(strs[i].split("=")[1])
        }
      }
      return theRequest
    },
    backHistory() {
      if(this.newRouterGo){
        window.location.href = this.newRouterGo
      }else{
        this.$router.go(-1) //返回上一层
      }
    },
    closeEditPageName: function (event) {
      if (!event.target.getAttribute("class") || !event.target.getAttribute("class").includes("page-name-inp")) {
        this.cancleEditPageName()
      }
    },
    getListOrder() {
      return this.$API.queryPageAttr({ websiteId: this.websiteId })
    },
    getListData() {
      return this.$API.queryEditPageList({
        websiteId: this.websiteId,
        pageId: this.pageId
      })
      // .then(res => {
      //   if (res.data.code === 1) {
      //     let pageList = res.data.data.pageList
      //     if (pageList && pageList.length > 0) {
      //       this.pagelist = pageList.filter(item => !item.template.includes("_sub"))
      //     }
      //   }
      // })
    },
    showPageList() {
      instance.all([this.getListData(), this.getListOrder()]).then(res => {
        const pageJson = res[1]?.data?.data?.pageListJson
        this.originalList = res[0].data.data.pageList.filter(item => !item.template.includes("_sub") && !item.template.includes("_header"))
        if (!res[1].data.data || !pageJson) {
          this.pagelist = this.originalList
          return
        }
        this.pageOrder = JSON.parse(pageJson).pages
        // 兼容改接口之后生成的一些无效数据
        for (let i = 0; i < this.pageOrder.length; i++) {
          if (!this.pageOrder[i].pageId) {
            this.pageOrder.splice(i, 1)
            i--
          }
        }
        let pagelist = []
        // 不能直接用this.pageOrder来遍历，有一种情况是先拖拽了顺序，然后去登录设置里面加了一个登录页，如果用this.pageOrder来遍历登录页就被筛选掉了
        // this.pageOrder.forEach((item, index) => {
        //   for (let i = 0; i < this.originalList.length; i++) {
        //     if (this.originalList[i].encId == item.pageId || this.originalList[i].publicId == item.pageId) {
        //       pagelist[index] = this.originalList[i]
        //       // 做老数据的兼容，以前用的是encId   现在改用publicId
        //       if (this.originalList[i].encId == item.pageId) {
        //         item.pageId = this.originalList[i].publicId
        //       }
        //       break
        //     }
        //   }
        // })
        pagelist = this.originalList.sort((pageA, pageB) => {
          const serialA = this.pageOrder.findIndex(item => item.pageId === pageA.publicId)
          const serialB = this.pageOrder.findIndex(item => item.pageId === pageB.publicId)
          return (serialA === -1 ? 1000 : serialA) - (serialB === -1 ? 1000 : serialB)
        })
        this.pagelist = pagelist
        this.$forceUpdate()
      })
    },
    getNewPageList() {
      this.$API
        .queryEditPageList({
          websiteId: this.websiteId,
          pageId: this.pageId
        })
        .then(res => {
          let pagelist = []
          this.originalList = res.data.data.pageList.filter(item => !item.template.includes("_sub") && !item.template.includes("_header"))
          // this.pageOrder.forEach((item, index) => {
          //   for (let i = 0; i < this.originalList.length; i++) {
          //     if (this.originalList[i].publicId === item.pageId) {
          //       pagelist[index] = this.originalList[i]
          //       break
          //     }
          //   }
          // })
          pagelist = this.originalList.sort((pageA, pageB) => {
            const serialA = this.pageOrder.findIndex(item => item.pageId === pageA.publicId)
            const serialB = this.pageOrder.findIndex(item => item.pageId === pageB.publicId)
            return (serialA === -1 ? 1000 : serialA) - (serialB === -1 ? 1000 : serialB)
          })
          this.pagelist = pagelist
        })
    },
    editPageName(index, name) {
      this.editIndex = index
      this.pageName = name
    },
    cancleEditPageName() {
      this.editIndex = undefined
    },
    saveEditPageName(page) {
      this.pagelist[this.editIndex].name = this.pageName
      this.editIndex = undefined
      this.$API
        .updatePageName({
          pageId: page.publicId,
          name: this.pageName,
          wfwfid: this.wfwfid
        })
        .then(res => {
          this.$message({
            customClass: "bigScreen_msg_backGroud",
            duration: 3000,
            message: "修改成功",
            type: "success"
          })
        })
        .catch(err => {
          this.$message({
            customClass: "bigScreen_msg_backGroud",
            duration: 3000,
            message: "修改失败",
            type: "error"
          })
        })
    },
    //  删除page
    deletePage(publicId, index) {
      // 从当前页面进来不允许删除
      // debugger
      // if (publicId === this.pageId) {
      //   this.$message({
      //     customClass: "bigScreen_msg_backGroud",
      //     duration: 3000,
      //     message: "请切换到首页后再删除该页面!",
      //     type: "warning"
      //   })
      //   return
      // }
      this.$confirm("删除后不能恢复，确定删除？", "提示", {
        confirmButtonText: "删除",
        cancelButtonText: "保留",
        type: "warning",
        center: true
      })
        .then(() => {
          this.$API
            .deletePage({
              pageId: publicId,
              params: {
                wfwfid: this.wfwfid
              }
            })
            .then(res => {
              this.pageOrder.splice(index, 1)
              this.pagelist.splice(index, 1)
              this.savePageSet(true, true)
              this.getNewPageList()
              this.$message({
                customClass: "bigScreen_msg_backGroud",
                duration: 3000,
                message: "删除成功",
                type: "success"
              })
              // 删除当前页面
              if(publicId === this.pageId){
                let href = this.$router.history._startLocation
                href = replaceUrlParam(href, "p", this.pagelist[0].publicId)
                this.newRouterGo = this.$router.history.base + href
              }
            })
        })
        .catch(() => {
          // this.$message({ customClass: "bigScreen_msg_backGroud", duration: 3000, type: "info", message: "已取消删除" })
        })
    },
    selectSubPage(template) {
      this.pageTitle = template.name
      // if (!this.templatePageName) {
      //   this.templatePageName = template.name
      // }
      this.templatePageName = template.name
      this.templatePageId = template.encId
    },
    nextClick() {
      if (!this.templatePageId) {
        this.$message({
          customClass: "bigScreen_msg_backGroud",
          duration: 3000,
          message: "请选择模板",
          type: "warning"
        })
        return
      }
      this.getSubPageList(this.templatePageId)
    },
    selectTemplatePage(template, index) {
      if (!this.templatePageName) {
        this.templatePageName = template.name
      }
      this.subTemplatePageId = template.encId
    },
    openTemplatePop() {
      this.showTemplates = true
      if (this.pageTemplates.length === 0) {
        this.getTemplates()
      }else{
        this.templatePageId = this.pageTemplates[0]?.encId
        this.templatePageName =  this.pageTemplates[0]?.name
      }
    },
    closeTemplate() {
      this.templatePageId = null
      this.showTemplates = false
    },
    changeTemplateType(item) {
      if (item.typeId === this.activeTemplateId) {
        return
      }
      this.activeTemplateId = item.typeId
      this.systemType = item.systemType
      this.getTemplates()
    },
    //获取页面模板列表
    getTemplates: function () {
      let _this = this
      const params = {
        systemType: this.systemType,
        typeId: this.activeTemplateId,
        pageNum: 1,
        pageSize: 100,
        hide: 1
      }
      // 加了新参数t2，而不是直接替换typeId，是为了兼容历史数据查询
      if (this.activeTemplateId === 299) {
        params.t2 = this.isPhoneFullScreenFlag == "true" ? 203 : 202
      }
      instance
        .get(this.contextPath + "v2/template-page/list", {
          params
        })
        .then(res => {
          if (res.data.code === 1) {
            _this.pageTemplates = res.data.data.list
            // 默认选择第一个模版
            _this.templatePageId = _this.pageTemplates[0]?.encId
            _this.templatePageName= _this.pageTemplates[0]?.name
          }
        })
    },
    addPage: _debounce(function () {
      this.loading = true
      this.$API
        .clonePage({
          w: this.websiteId,
          t: this.templatePageId,
          n: this.templatePageName
        })
        .then(res => {
          this.loading = false
          // if (res.data.status !== 200 || res.data.code === 0) {
          //   return Promise.reject({ message: res?.data?.message })
          // }
          this.pageOrder.push({
            pageId: res.data.data.publicId
          })
          this.pagelist.push(res.data.data)
          this.savePageSet(true)
          this.getNewPageList()
          this.closeTemplate()
          // todo 自动跳转到新建页面
          this.toEdit(res.data.data)
          // debugger
        })
        .catch(err => {
          this.loading = false
          this.$message({
            type: "error",
            customClass: "bigScreen_msg_backGroud",
            message: getErrorMessage(err?.message, true) || "添加失败"
          })
        })
    }, 200),
    addSubPage: function () {
      this.loading = true
      this.$API
        .clonePages({
          w: this.websiteId,
          ids: "ids" + encodeURI("[]") + "=" + this.subTemplatePageId
        })
        .then(res => {
          this.loading = false
          let len = res.data.data?.length
          if (len > 0) {
            this.pageOrder.push({
              pageId: res.data.data[len - 1]?.publicId
            })
            this.pagelist.push(res.data.data[len - 1])
          }
          this.savePageSet(true)
          this.getNewPageList()
          this.closeTemplate()
        })
        .catch(err => {
          this.loading = false
          this.$message({
            type: "error",
            customClass: "bigScreen_msg_backGroud",
            message: getErrorMessage(err?.message, true) || "添加失败"
          })
        })
    },
    savePageSet: function (notUpdateOrder, noTips) {
      if (!notUpdateOrder || this.pageOrder.length !== this.pagelist.length) {
        let pages = []
        this.pagelist.forEach(item => {
          let page = {
            pageId: item.publicId
          }
          pages.push(page)
        })
        this.originalList.forEach(item => {
          let hasVal = false
          for (let i = 0; i < pages.length; i++) {
            if (item.publicId === pages[i].pageId) {
              hasVal = true
              break
            }
          }
          if (!hasVal) {
            pages.push({ pageId: item.publicId })
          }
        })
        this.pageOrder = pages
      }
      this.$API
        .updatePageAttr({
          encWebId: this.websiteId,
          pageListJson: JSON.stringify({
            pages: this.pageOrder,
            swiperOption: {
              time: this.autoPlaySpeed,
              autoplay: this.autoplay
            }
          })
        })
        .then(res => {
          if (res.data.code === 1) {
            !noTips &&
              this.$message({
                customClass: "bigScreen_msg_backGroud",
                duration: 3000,
                message: "保存成功",
                type: "success"
              })
          }
        })
    },
    getSubPageList(encId) {
      this.loading = true
      let _this = this
      let contextPath = window.hasOwnProperty("p_contextpath") ? window["p_contextpath"] : ""
      this.$API
        .queryPageListByTemplateId({
          templateId: encId
        })
        .then(res => {
          let pageList = res.data.data.pageList
          if (pageList && pageList.length > 0) {
            // 过滤掉子页面
            _this.subPageTemplate = pageList.filter(item => !item.template.includes("_sub") && !item.template.includes("_header"))
            _this.subTemplatePageId =  _this.subPageTemplate[0]?.encId
          }
          // 如果子页面大于1个 才能往下选择 否则直接添加
          if (_this.subPageTemplate?.length > 1) {
            this.loading = false
            _this.showSubPage = true
          } else {
            _this.addPage()
          }
        })
        .catch(error => {
          this.loading = false
        })
    }
  }
}
</script>

<style lang="scss" scoped>
.bigScreen-list {
  background: #fff;
}
.save {
  background: white;
  border: 1px solid var(--themeColor);
  border-radius: 4px;
  width: 60px;
  height: 32px;
  padding: 0;
}
.page-top {
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  padding: 8px 24px;
  background: #1d304a;
  color: #fff;
}
.backpage:hover {
  color: var(--themeColor);
  cursor: pointer;
}
.page-top-r,
.page-top-l {
  width: 300px;
}
.talign-center {
  text-align: center;
}
.w900 {
  width: 900px;
}
.middle-content {
  margin: 24px auto;
}
.page-sets {
  padding: 0 16px;
  box-sizing: border-box;
  justify-content: space-between;
}
.page-cover {
  width: 130px;
  height: 74px;
  margin-right: 20px;
  border-radius: 4px;
  object-fit: cover;
}
.page-list {
  position: relative;
  padding: 12px 20px 12px 56px;
  box-sizing: border-box;
  margin-bottom: 4px;
  border-radius: 8px;
}
.page-list.sortable-chosen {
  border-radius: 8px 8px 0 0;
  border-bottom: 2px solid #0000ff;
}
.page-list .hover-show {
  display: none;
}
.page-list:hover {
  background: #f3f7fe;
}
.page-list:hover .hover-show {
  display: inline-block;
}
.page-list .icon-portal-edit {
  color: #2f2e3f;
  font-size: 18px;
  cursor: pointer;
}
.page-list .icon-portal-delete {
  font-size: 18px;
}
.page-list .icon-portal-drag {
  position: absolute;
  z-index: 1;
  left: 20px;
  top: 50%;
  margin-top: -12px;
  color: rgba(0, 0, 0, 0.6);
}
.page-name span {
  font-weight: normal;
  cursor: pointer;
}
.right-btns {
  width: 120px;
  text-align: right;
}
.icon {
  display: inline-block;
  width: 24px;
  height: 24px;
  line-height: 24px;
  text-align: center;
  cursor: pointer;
  border-radius: 4px;
}
.icon:hover {
  color: var(--themeColor);
  background-color: rgba(61, 130, 242, 0.1);
}
.icon-portal-delete {
  color: rgba(0, 0, 0, 0.4);
}
.icon-portal-drag {
  cursor: move;
}
.icon-portal-drag:hover {
  cursor: grab;
}
.icon-portal-drag:active {
  cursor: grabbing;
}
.page-name {
  width: 638px;
  color: rgba(0, 0, 0, 0.8);
  font-size: 18px;
  line-height: 24px;
  font-weight: 600;
}
.page-name-inp {
  width: 200px;
  height: 36px;
  border: 1px solid #eee;
  border-radius: 4px;
  padding: 0 8px;
  margin-right: 24px;
  font-size: 16px;
}
.el-message-box__wrapper {
  background: rgba(0, 0, 0, 0.4);
}
.el-message-box {
  width: 800px;
}
#pageContainer {
  max-height: 460px;
  overflow-y: auto;
}
.pages-styles {
  font-size: 0;
  margin-top: 15px;
  max-height: 350px;
  overflow-y: auto;
  > li {
    display: inline-block;
    vertical-align: top;
    margin-bottom: 16px;
    &:hover {
      .page-img {
        border: 2px solid var(--themeColor);
      }
    }
    &.active {
      .page-img {
        border: 2px solid var(--themeColor);
      }
    }
    &:not(:nth-child(3n)) {
      margin-right: 12px;
    }
  }
  p {
    font-size: 14px;
    line-height: 20px;
    text-align: center;
    word-break: break-all;
  }
  .cover-box {
    position: relative;
    width: 240px;
    height: 150px;
    text-align: center;
    border-radius: 8px;
    overflow: hidden;
    margin-bottom: 10px;
    .page-img {
      border-radius: 8px;
      border: 2px solid var(--alertBackGround);
      object-fit: cover;
    }
    .checked {
      position: absolute;
      right: 0;
      top: 0;
      width: 32px;
    }
  }
  .page-img {
    width: 100%;
    height: 100%;
    box-sizing: border-box;
  }
  &.maxHeight500 {
    max-height: 500px;
  }
}
.inp-name {
  display: inline-block;
  vertical-align: middle;
  margin-left: 8px;
  padding: 0 30px 0 8px;
  width: 240px;
  height: 30px;
  background: #fff;
  border-radius: 2px;
  border: 1px solid #ddd;
  box-sizing: border-box;
  &:hover,
  &:focus {
    border: 1px solid var(--themeColor);
  }
  &:focus + .icon-portal-search {
    color: var(--themeColor);
  }
}
::v-deep .el-input .el-input__inner {
  color: rgba(0, 0, 0, 0.8);
  background: #ffffff;
  border: 1px solid #e9e9e9;
}
::v-deep .el-slider__bar {
  background: var(--themeColor);
}
::v-deep .el-slider__button {
  border: 2px solid var(--themeColor);
  background-color: #fff;
}
::v-deep .el-message-box__wrapper .el-button--primary {
  color: #fff;
}
.el-button--primary.save {
  color: #fff;
}
.el-message-box__header {
  padding: 15px 24px 10px;
}
.el-message-box__content {
  padding: 10px 14px 10px 24px;
}
.el-message-box__btns {
  padding: 16px 24px;
  border-top: 1px solid rgba(0, 0, 0, 0.07);
}
.el-message-box {
  padding-bottom: 0;
}
.templates-types {
  margin-top: 12px;
  > li {
    display: inline-block;
    margin-right: 12px;
    cursor: pointer;
    &.active {
      color: var(--themeColor);
    }
  }
}
#pageContainer .empty {
  text-align: center;
  padding: 50px 0;
  box-sizing: border-box;
}
.hover-theme-color:hover {
  color: var(--themeColor);
  cursor: pointer;
}
.marginTop0 {
  margin-top: 0;
}
.return-btn {
  cursor: pointer;
  display: flex;
  align-items: center;
  font-size: 16px;
  i {
    font-size: 24px;
    margin-right: 4px;
  }
}
</style>
